import { render, staticRenderFns } from "./InterpreterPhone.vue?vue&type=template&id=425647d2&scoped=true&"
import script from "./InterpreterPhone.vue?vue&type=script&lang=js&"
export * from "./InterpreterPhone.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterPhone.vue?vue&type=style&index=0&id=425647d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425647d2",
  null
  
)

export default component.exports